import { generateAIAgentSchema } from "ee/actions/generateSchemaActions";
import { usePluginActionContext } from "PluginActionEditor/PluginActionContext";
import { useCallback } from "react";
import { useDispatch } from "react-redux";

export function useHandleGenerateAISchemaSchemaClick() {
  const { action } = usePluginActionContext();
  const dispatch = useDispatch();

  const handleGenerateAISchemaSchemaClick = useCallback(() => {
    dispatch(generateAIAgentSchema(action?.id ?? ""));
  }, [action?.id, dispatch]);

  return { handleGenerateAISchemaSchemaClick };
}
